import React from 'react';
import ModuleRoute from 'holocron-module-route';
import ErrorLayout from './components/error/ErrorLayout';
import ErrorPage from './components/error/ErrorPage';
import LOG_EVENTS from './analytics/p2p';

const Routes = () => [
  <ModuleRoute key="paypal">
    <ModuleRoute path="p2p-us/paypal" moduleName="axp-peer-payments-partner-page-wrapper">
      <ModuleRoute path="send-and-split" title="Introduction" moduleName="axp-peer-payments-partner-send-and-split" analytics={LOG_EVENTS.INTRO} />
      <ModuleRoute path="select" title="Account" moduleName="axp-peer-payments-partner-select-account" analytics={LOG_EVENTS.SELECT} />
      <ModuleRoute path="message(/:enum)" title="Message" moduleName="axp-peer-payments-partner-message" analytics={LOG_EVENTS.ERROR} />
      <ModuleRoute path="enroll" title="Enroll" moduleName="axp-peer-payments-partner-send-and-split-enroll" analytics={LOG_EVENTS.ENROLL} />
      <ModuleRoute path="verify" title="Verification" moduleName="axp-peer-payments-partner-verification" analytics={LOG_EVENTS.VERIFY} />
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute key="venmo">
    <ModuleRoute path="p2p-us/venmo" moduleName="axp-peer-payments-partner-page-wrapper">
      <ModuleRoute path="send-and-split" title="Introduction" moduleName="axp-peer-payments-partner-send-and-split" analytics={LOG_EVENTS.INTRO} />
      <ModuleRoute path="select" title="Account" moduleName="axp-peer-payments-partner-select-account" analytics={LOG_EVENTS.SELECT} />
      <ModuleRoute path="message(/:enum)" title="Message" moduleName="axp-peer-payments-partner-message" analytics={LOG_EVENTS.ERROR} />
      <ModuleRoute path="enroll" title="Enroll" moduleName="axp-peer-payments-partner-send-and-split-enroll" analytics={LOG_EVENTS.ENROLL} />
      <ModuleRoute path="verify" title="Verification" moduleName="axp-peer-payments-partner-verification" analytics={LOG_EVENTS.VERIFY} />
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute key="webEnrollment">
    <ModuleRoute path="p2p-us/webenrollment" moduleName="axp-peer-payments-partner-page-wrapper">
      <ModuleRoute path="send-and-split" title="Introduction" moduleName="axp-peer-payments-partner-send-and-split" analytics={LOG_EVENTS.INTRO} />
      <ModuleRoute path="select" title="Account" moduleName="axp-peer-payments-partner-select-account" analytics={LOG_EVENTS.SELECT} />
      <ModuleRoute path="message(/:enum)" title="Message" moduleName="axp-peer-payments-partner-message" analytics={LOG_EVENTS.ERROR} />
      <ModuleRoute path="enroll" title="Enroll" moduleName="axp-peer-payments-partner-send-and-split-enroll" analytics={LOG_EVENTS.ENROLL} />
      <ModuleRoute path="verify" title="Verification" moduleName="axp-peer-payments-partner-verification" analytics={LOG_EVENTS.VERIFY} />
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute key="addMoney">
    <ModuleRoute path="p2p-us/addmoney" moduleName="axp-peer-payments-partner-page-wrapper">
      <ModuleRoute path="send-and-split" title="Introduction" moduleName="axp-peer-payments-partner-send-and-split" analytics={LOG_EVENTS.INTRO} />
      <ModuleRoute path="message(/:enum)" title="Message" moduleName="axp-peer-payments-partner-message" analytics={LOG_EVENTS.ERROR} />
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute key="errorRoute" component={ErrorLayout}>
    <ModuleRoute
      code="500"
      component={ErrorPage}
      path="*/error"
      status={500}
    />
    <ModuleRoute
      code="404"
      component={ErrorPage}
      path="*"
      status={404}
    />
  </ModuleRoute>,
];

export default Routes;
